<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZTQK57/tc-custom/cover.jpg?1684571217590?1723405090809" alt="This image is the cover for the book Tortilla Pie"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tortilla Pie
      </h1>
      <p class="bookDescription body article font2">
        <p>When Anderson, homeless on the streets of Seattle, first spies Josh, a volunteer at TeenCare, he immediately falls for him, even though TeenCare forbids client/volunteer interaction. Anderson thinks: "And speaking of noticed, I think I was, just a few minutes ago. One of the volunteers was coming by and we locked eyes. You know, the way two guys do. Two gay guys, anyway, who like what they see. It's not like a casual glance -- those only last for a second or maybe two at the most -- but when two gay dudes notice each other, man, that eye-to-eye lingers. You know what I'm sayin'?<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rick R. Reed
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?140757f7